import { render, staticRenderFns } from "./Finals.vue?vue&type=template&id=9827b7d8&scoped=true"
import script from "./Finals.vue?vue&type=script&lang=js"
export * from "./Finals.vue?vue&type=script&lang=js"
import style0 from "./Finals.vue?vue&type=style&index=0&id=9827b7d8&prod&lang=scss&scoped=true"
import style1 from "./Finals.vue?vue&type=style&index=1&id=9827b7d8&prod&lang=scss&scoped=true"
import style2 from "./Finals.vue?vue&type=style&index=2&id=9827b7d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9827b7d8",
  null
  
)

export default component.exports